export default "__VITE_ASSET__n6K9Yx8k__"